import styled from 'styled-components'

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const DownloadAllButton = styled.button`
  cursor: pointer;
  width: 10rem;
  height: 2rem;
  margin: 1rem;
  background-color: ${(props) => props.theme.colors.primaryColor300};
  border: none;
  border-radius: 4px;
  color: ${(props) => props.theme.colors.black};
  &:hover {
    background-color: ${(props) => props.theme.colors.primaryColor100};
  }
`
export const LoadingDownloadButton = styled(DownloadAllButton)`
  pointer-events: none;
`
export const StyledTable = styled.table`
  width: 100%;
`
export const StyledThead = styled.thead`
  width: 100%;
  color: ${(props) => props.theme.colors.grey};
`
export const StyledTbody = styled.tbody`
  color: ${(props) => props.theme.colors.white};
`

export const StyledTh = styled.th`
  padding: 0.5rem 1rem;
  text-align: ${(props) => props.align};
  cursor: pointer;
  &.active {
    font-weight: 700;
    color: ${(props) => props.theme.colors.primaryColor500};
  }
`

export const StyledTd = styled.td`
  padding: 0.5rem 1rem;
  text-align: ${(props) => props.align};
`
export const ViewButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0.5rem 1rem;
  color: ${(props) => props.theme.colors.whiteAlpha40};
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    color: ${(props) => props.theme.colors.primaryColor500};
  }
  &:focus {
    outline: none;
    background-color: ${(props) => props.theme.colors.neutralColor500};
  }
  &:disabled {
    cursor: default;
    background-color: transparent;
    &:hover {
      color: ${(props) => props.theme.colors.whiteAlpha20};
    }
  }
`
